module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/art-map-large-d72e362c4bd590d0df3b23753f841055.jpg";